var map = {
	"./hellohr/circle-3.png": "DyMF"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fdpi";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\/circle\-3\.png$
// module id = fdpi
// module chunks = 0